import { render, staticRenderFns } from "./formview.vue?vue&type=template&id=cba9856a"
import script from "./formview.vue?vue&type=script&lang=js"
export * from "./formview.vue?vue&type=script&lang=js"
import style0 from "./formview.vue?vue&type=style&index=0&id=cba9856a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports